export const selectActions = /** @type {const} */ ({
  FETCH: "FETCH",
  SELECT: "SELECT",
  DESELECT: "DESELECT",
  SELECT_ALL: "SELECT_ALL",
  DESELECT_ALL: "DESELECT_ALL",
  UPDATE_LIST: "UPDATE_LIST",
  JSON_READY: "JSON_READY",
  JSON_SELECTION: "JSON_SELECTION",
  JSON_ALL: "JSON_ALL",
  JSON_ALL_STARTED: "JSON_ALL_STARTED",
  JSON_ALL_PROGRESS: "JSON_ALL_PROGRESS",
  JSON_ALL_PAUSE: "JSON_ALL_PAUSE",
  JSON_ALL_RESUME: "JSON_ALL_RESUME",
  JSON_CANCEL: "JSON_CANCEL",
  JSON_RETRANSFORM: "JSON_RETRANSFORM",
});

const userInfo = {
  label: "User Info",
  fields: {
    participantId: "Participant ID",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    role: "Role",
    dateJoined: "Date Joined",
    isActivated: "Activation Status",
    preTestActivated: "Quiz 1 Activation Status",
    postTestActivated: "Quiz 2 Activation Status",
    postDrivingTestActivated: "Quiz 3 Activation Status",
    trainingsActivated: "Training Activation Status",
    inPerson: "In-Person Status",
    devices: "Known Devices",
  },
};

const taskInfo = {
  label: "Task Info",
  fields: {
    id: "Task ID",
    isStarted: "Started Status",
    isCompleted: "Completion Status",
    isActivated: "Activation Status",
    incompleteModuleId: "Incomplete Module ID",
    incompleteScenarioId: "Incomplete Scenario ID",
    incompleteActivityId: "Incomplete Activity ID",
  },
};

const moduleInfo = {
  label: "Module Info",
  fields: {
    id: "Module ID",
    type: "Module Type",
    isTrain: "Is Training",
    isStarted: "Started Status",
    isCompleted: "Completion Status",
  },
};

const scenarioInfo = {
  label: "Scenario Info",
  fields: {
    id: "Scenario ID",
    type: "Scenario Type",
    isStarted: "Started Status",
    isCompleted: "Completion Status",
  },
};

const activityInfo = {
  label: "Activity Info",
  fields: {
    id: "Activity ID",
    type: "Activity Type",
    assetPath: "Asset Path",
    hitboxCoordinates: "Hit-box Coordinates",
    hitboxRadii: "Hit-box Radii",
    hitboxCoordinatesResponses: "Hit-box Responses",
    rearviewNotAllowed: "Rear-View Not Allowed",
    rearviewNotAllowedResponses: "Rear-View Not Allowed Responses",
    userGlanceStates: "User Glance States",
    userGridResponse: "User Grid Response",
    correctGridResponse: "Correct Grid Response",
    responseStartTimes: "Response Start Times",
    responseEndTimes: "Response End Times",
    lastCorrectIndex: "Index of Last Correct Response",
    hasCorrectAnswer: "Has Correct Answer",
    isStarted: "Started Status",
    isCompleted: "Completion Status",
    practiceMode: "Is Practice Mode",
  },
};

export const userTransform = /** @type {const} */ ({
  user: userInfo,
  task: taskInfo,
  module: moduleInfo,
  scenario: scenarioInfo,
  activity: activityInfo,
});

/**
 * @typedef {{
 *   label: string;
 *   fields: {
 *     [k in keyof userTransform]: (keyof userTransform[k]["fields"])[];
 *   };
 * }} QuickSelect
 */

export const allDataPreset = "allData";

export const quickSelectOptions = {
  /** @type {QuickSelect} */
  userSummary: {
    label: "User Summary",
    fields: {
      user: [
        "participantId",
        "firstName",
        "lastName",
        "email",
        "role",
        "dateJoined",
      ],
    },
  },
  /** @type {QuickSelect} */
  responseTimes: {
    label: "Response Times",
    fields: {
      activity: ["type", "responseStartTimes", "responseEndTimes"],
    },
  },
  /** @type {QuickSelect} */
  [allDataPreset]: {
    label: "All Data",
    fields: {
      user: Object.keys(userInfo.fields),
      task: Object.keys(taskInfo.fields),
      module: Object.keys(moduleInfo.fields),
      scenario: Object.keys(scenarioInfo.fields),
      activity: Object.keys(activityInfo.fields),
    },
  },
};
